/* =============================================
   Header Section — Extracted from header.liquid
   ============================================= */

/* -- Mega menu click handler (desktop) -- */
document.addEventListener('click', function(e) {
  if (window.innerWidth < 990) return;
  var summary = e.target.closest('header-menu.custom-mega-menu details.mega-menu > summary');
  if (!summary) return;

  e.preventDefault();
  var currentDetails = summary.parentElement;
  var isOpen = currentDetails.hasAttribute('open');

  document.querySelectorAll('header-menu.custom-mega-menu details.mega-menu[open]').forEach(function(openDetails) {
    openDetails.removeAttribute('open');
    openDetails.querySelector('summary').setAttribute('aria-expanded', 'false');
  });

  if (!isOpen) {
    currentDetails.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');
  }
});

/* -- Mobile accordion toggle -- */
(function() {
  var accordionItemHeaders = document.querySelectorAll(".header_menu_accordion__title .accordion__cust_btn");

  accordionItemHeaders.forEach(function(accordionItemHeader) {
    accordionItemHeader.addEventListener("click", function(event) {
      event.preventDefault();

      accordionItemHeader.classList.toggle("active");
      var accordionItemBody = accordionItemHeader.nextElementSibling;

      if (accordionItemHeader.classList.contains("active")) {
        accordionItemBody.classList.add("active");
      } else {
        accordionItemBody.classList.remove("active");
      }
    });
  });
})();

/* -- Search modal & scroll handler -- */
document.addEventListener("DOMContentLoaded", function () {
  var searchDetails = document.querySelector('.header__search details');

  if (!searchDetails) return;

  var observer = new MutationObserver(function() {
    if (searchDetails.hasAttribute('open')) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  });

  observer.observe(searchDetails, { attributes: true, attributeFilter: ['open'] });
});


/* -- Header Search Animation -- */
(function () {

  document.addEventListener('click', function(e){
    if (e.target.closest('.search-modal__close-button')) {
      var modal = e.target.closest('details-modal');
      if (modal) modal.close();
    }
  });

  function init() {
    var DetailsModalClass = customElements.get('details-modal');
    if (!DetailsModalClass) return;

    var HIDDEN_CLASS = 'search-modal--hidden';
    var activeAnims = new WeakMap();
    var isClosing = new WeakSet();

    var OPEN_KF = [
      { transform: 'translateY(100%)', opacity: '0' },
      { transform: 'translateY(0)', opacity: '1' }
    ];

    var CLOSE_KF = [
      { transform: 'translateY(0)', opacity: '1' },
      { transform: 'translateY(100%)', opacity: '0' }
    ];

    var OPEN_OPT = {
      duration: 420,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      fill: 'forwards'
    };

    var CLOSE_OPT = {
      duration: 380,
      easing: 'cubic-bezier(0.4, 0, 0.8, 1)',
      fill: 'forwards'
    };

    function getModal(el) {
      return el.querySelector('.search-modal.modal__content');
    }

    function cancelAnim(modal) {
      var a = activeAnims.get(modal);
      if (a) {
        try { a.cancel(); } catch(e){}
        activeAnims.delete(modal);
      }
    }

    function doOriginalOpen(inst, event) {
      inst.onBodyClickEvent = inst.onBodyClickEvent || inst.onBodyClick.bind(inst);

      event.target.closest('details').setAttribute('open', true);

      document.body.addEventListener('click', inst.onBodyClickEvent);
      document.body.classList.add('overflow-hidden');

      trapFocus(
        inst.detailsContainer.querySelector('[tabindex="-1"]'),
        inst.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }

    function doOriginalCloseCleanup(inst, ft) {
      removeTrapFocus(ft ? inst.summaryToggle : null);
      inst.detailsContainer.removeAttribute('open');
    }

    var modal = document.querySelector('.search-modal.modal__content');
    if (modal && !document.querySelector('details-modal details[open]')) {
      modal.classList.add(HIDDEN_CLASS);
    }
  }

  if (customElements.get('details-modal')) {
    init();
  } else {
    customElements.whenDefined('details-modal').then(init);
  }

})();


/* -- Search modal position (scroll-aware) -- */
(function () {
  var MOBILE_BP = 749;

  var mobileStyle = document.createElement('style');
  mobileStyle.id = 'search-modal-top-fix';
  mobileStyle.textContent = [
    '  body .search-modal.modal__content {',
    '    top: var(--search-modal-top, 85px) !important;',
    '    -webkit-inset-block-start: var(--search-modal-top, 85px) !important;',
    '    inset-block-start: var(--search-modal-top, 85px) !important;',
    '  }',
    '@media screen and (max-width: ' + MOBILE_BP + 'px) {',
    '  body .search-modal.modal__content {',
    '    top: var(--search-modal-top, 65px) !important;',
    '    -webkit-inset-block-start: var(--search-modal-top, 65px) !important;',
    '    inset-block-start: var(--search-modal-top, 65px) !important;',
    '  }',
    '}'
  ].join('\n');
  document.head.appendChild(mobileStyle);

  var headerSectionEl = document.querySelector('.section-header');
  var mobileStickyH   = headerSectionEl ? headerSectionEl.offsetHeight : 65;

  function updateSearchModalTop() {
    var scrollY  = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement.scrollTop || document.body.scrollTop || 0);
    var isMobile = window.innerWidth <= MOBILE_BP;

      if (scrollY <= 0) {
        document.documentElement.style.removeProperty('--search-modal-top');
      } else {
        document.documentElement.style.setProperty('--search-modal-top', mobileStickyH + 'px');
      }

  }

  window._searchModalTopHandler = updateSearchModalTop;
  window.addEventListener('scroll', updateSearchModalTop, { passive: true });

  var modal = document.querySelector('.search-modal.modal__content');
  if (modal) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes' && m.attributeName === 'style') {
          var vis = modal.style.visibility;
          var disp = modal.style.display;
          var opacity = modal.style.opacity;
          if (vis === 'visible' || (disp && disp !== 'none') || opacity === '1') {
            updateSearchModalTop();
            break;
          }
        }
        if (m.type === 'attributes' && m.attributeName === 'class') {
          updateSearchModalTop();
          break;
        }
      }
    });

    observer.observe(modal, {
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    var detailsParent = modal.closest('details');
    if (detailsParent) {
      var detailsObserver = new MutationObserver(function () {
        if (detailsParent.hasAttribute('open')) {
          updateSearchModalTop();
        }
      });
      detailsObserver.observe(detailsParent, {
        attributes: true,
        attributeFilter: ['open']
      });
      window._searchModalDetailsObserver = detailsObserver;
    }

    window._searchModalObserver = observer;
  }

  updateSearchModalTop();
})();


/* -- Sticky Header Web Component -- */
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.menu = document.querySelector('.login-and-toolmenu');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop !== this.currentScrollTop) this.closeMenuDisclosure();

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.closeMenuDisclosure();
    this.closeSearchModal();
    if (this.menu.classList.contains('active')) {
      this.menu.classList.remove('active');
    }
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => {
      if (typeof disclosure.close === 'function') disclosure.close();
    });
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal && typeof this.searchModal.close === 'function') this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);
